/**
 * Global Swiper loader — lazy-loads Swiper CSS + JS from CDN once,
 * returns a Promise that resolves when both are ready.
 *
 * Usage from any section:
 *   window.loadSwiper().then(() => {
 *     new Swiper('.my-container', { ... });
 *   });
 */
(function () {
  const SWIPER_CSS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
  const SWIPER_JS = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';

  let promise = null;

  function loadTag(tag, attrs) {
    return new Promise((resolve, reject) => {
      const selector = tag === 'link' ? `link[href="${attrs.href}"]` : `script[src="${attrs.src}"]`;
      if (document.querySelector(selector)) return resolve();
      const el = document.createElement(tag);
      Object.assign(el, attrs);
      el.onload = resolve;
      el.onerror = reject;
      document.head.appendChild(el);
    });
  }

  function waitForSwiper(timeoutMs) {
    return new Promise(function (resolve, reject) {
      if (window.Swiper) return resolve();
      var start = Date.now();
      var interval = setInterval(function () {
        if (window.Swiper) {
          clearInterval(interval);
          resolve();
        } else if (Date.now() - start > timeoutMs) {
          clearInterval(interval);
          reject(new Error('Swiper failed to initialise'));
        }
      }, 20);
    });
  }

  window.loadSwiper = function () {
    if (!promise) {
      promise = Promise.all([
        loadTag('link', { rel: 'stylesheet', href: SWIPER_CSS }),
        loadTag('script', { src: SWIPER_JS }),
      ]).then(function () {
        return waitForSwiper(4000);
      });
    }
    return promise;
  };
})();
